import {
  TableLight as TemplateIcon,
  InfoLight as InfoIcon,
  BookOpenLight as BookIcon,
  SettingsDetailLightCustom,
  TrackLightCustom,
  DarhboardAltLight,
} from '@repo/go-icons';

import { DEV_SETTINGS_PAGE_AVAILABLE } from 'src/api/consts';

import styles from './SettingsGrid.module.scss';
import type { ISettingsNav } from './types';

export const getMenuItems = () => {
  const menuItems: ISettingsNav[] = [
    {
      id: '1',
      type: 'widgetsManager',
      Icon: <TemplateIcon className={styles.mainColumnIcon} />,
    },
    {
      id: '2',
      type: 'tabsManager',
      Icon: <BookIcon className={styles.mainColumnIcon} />,
    },
    {
      id: '5',
      type: 'basicParameters',
      Icon: <TrackLightCustom className={styles.mainColumnIcon} />,
    },
    // {
    //   id: '6',
    //   type: 'alerts',
    //   Icon: <BellLight className={styles.mainColumnIcon} />,
    // },
    {
      id: '7',
      type: 'others',
      Icon: <DarhboardAltLight className={styles.mainColumnIcon} />,
    },
  ];

  if (process.env.NODE_ENV !== 'production') {
    menuItems.push({
      id: '3',
      type: 'unitSystem',
      Icon: <InfoIcon className={styles.mainColumnIcon} />,
      disabled: true,
    });
  }

  if (DEV_SETTINGS_PAGE_AVAILABLE) {
    menuItems.push({
      id: '4',
      type: 'devSettings',
      Icon: <SettingsDetailLightCustom className={styles.mainColumnIcon} />,
    });
  }

  menuItems.sort((a, b) => a.id.localeCompare(b.id));

  return menuItems;
};
